import { UserOwnedVaultsRequestArgs } from "@decibeltrade/sdk";
import { FetchQueryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { readDexSdk } from "@/contexts/dex-sdk";

import { addSubaccountAddressToVault } from "./utils";

export function userVaultsQueryKey(address?: string) {
  return ["user-vaults", address] as const;
}

export function userOwnedVaultsQuery(args: UserOwnedVaultsRequestArgs) {
  return {
    queryKey: userVaultsQueryKey(args.ownerAddr),
    queryFn: async () => {
      const userVaults = await readDexSdk.vaults.getUserOwnedVaults(args);
      return {
        ...userVaults,
        items: userVaults.items.map(addSubaccountAddressToVault),
      };
    },
  } satisfies FetchQueryOptions;
}

export function useUserOwnedVaults(args: UserOwnedVaultsRequestArgs) {
  return useSuspenseQuery(userOwnedVaultsQuery(args));
}

export const useUserOwnedVaultsQuery = (accountAddress?: string) =>
  useQuery({
    ...userOwnedVaultsQuery({ ownerAddr: accountAddress?.toString() ?? "" }),
    enabled: !!accountAddress,
  });
